import('./pb23-filters--full.css');

const pb23FiltersFull = {
    init: function () {
        console.log('pb23-filters--full: STARTED!');
        $('button.all').off('click').on('click', function (e) {
            e.preventDefault();
            $(this).addClass('checked');
            $(this).parents('.filter-options').find('input[type="checkbox"]').prop('checked',false).removeClass('checked');
            $(this).parents('.filter-options').find('input[type="checkbox"]').first().trigger('change');
            $(this).parents('.filter-options').find('input[type="checkbox"]').first().trigger('change');
            //$(this).parents('.filter-options').find('.jsApplyFilter').addClass('disbaled').attr('disabled',true).prop('disabled',true);
            return false;
        });
        $('.jsClearTags').off('click').on('click', function (e) {
            e.preventDefault();
            $(this).parents('.filter-options').find('button.all').trigger('click');
            return false;
        }
        );
        // Replicado em productsDiscountsNew.js #368        
        $('body').off('click','.pb23-filters--full .jsSubmenu').on('click','.pb23-filters--full .jsSubmenu',function(e){
            e.preventDefault();
            var ele = $(this);
            var target = $(this).data('target');
            
            if (ele.hasClass('visible'))
            {
                ele.removeClass('visible');
                ele.siblings('.pb23-submenu').hide("blind",300);
                return false;
            }
            else
            {
                if (!pb23FiltersFull.mobileAndTabletCheck())
                {
                    $('.pb23-submenu').hide();
                }
                ele.siblings('.pb23-submenu').show("blind",300);
                ele.addClass('visible');
                return false;
            }
        
            return false;
        });
        $('body').off('click','.pb23-filters--full .jsAuxmenuToggle').on('click','.pb23-filters--full .jsAuxmenuToggle',function(){
            var target = "#" + $(this).attr('data-target');
            console.log("Ok: "+target);            
            if ($(window).width() > 601) {
                $(target).show(function(){$(target).find('.auxmenu--wrapper').toggle("drop",{direction:'right'},500)});
                return false;
            } else {
                $(target).show(function(){$(target).find('.auxmenu--wrapper').toggle("drop",{direction:'down'},500)});
                return false;
            }
        });
        $('body').off('click','.pb23-filters--full .jsAuxmenuClose').on('click','.pb23-filters--full .jsAuxmenuClose',function(){
            if ($(window).width() > 601) {
                $(this).closest(".pb23-auxmenu").find('.auxmenu--wrapper').toggle("drop",{direction:'right'},500,function(){$(this).closest(".pb23-auxmenu").hide();});
                return false;
            } else {
                $(this).closest(".pb23-auxmenu").find('.auxmenu--wrapper').toggle("drop",{direction:'down'},500,function(){$(this).closest(".pb23-auxmenu").hide();});
                return false;
            }
        });
        
        $('body').off('change','.pb23-filters--full .filter--menu.filter-options input[type="radio"][data-id="all"]').on('change','.pb23-filters--full .filter--menu.filter-options input[type="radio"][data-id="all"]',function(){
            var checked = $(this).is(':checked');
            if (checked)
            {
                $(this).parents('.wrapper').find('input[type="checkbox"]:checked').prop('checked',false);
            }
        });

        /*
        $('body').on('show.bs.collapse','.pb23-filters--full .filter-options', function (e) {
            var source = $(e.target).attr('id');
            localStorage.setItem("filter_" + source, 'show');
        });

        $('body').on('hide.bs.collapse', '.pb23-filters--full .filter-options', function (e) {
            $(this).children('button')

            var source = $(e.target).attr('id');
            localStorage.removeItem("filter_" + source);
        });    
        */
        
    },
    mobileAndTabletCheck: () => {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    },
}
// initialize component
window.loadedComponents.push({ component: 'pb23-filters--full', init: pb23FiltersFull.init});

export default() => {
    pb23FiltersFull.init();
}